export const pendingBookings = {
  configTitle: "Configurar reservas diretas",
  configText:
    "Ative as reservas diretas para gerenciar pagamentos pendentes e solicitações de reserva dos seus hóspedes aqui mesmo.",
  reminderLabel: "Lembrete:",
  reminderReasonIntent: "pagamento pendente de",
  reminderReasonUnassigned: "atribuir quarto a",
  reminderReasonRequest: "solicitação para revisar de",
  combined: "Combinado · {count} quartos",
  expired: "Expirado",
  toastSuccessTitle: "Sucesso",
  toastErrorTitle: "Erro",
  toastWarningTitle: "Aviso",
};
